module.exports = "./static/icon_success.36f308d6.png";